// Ekrany przed grą: logowanie / rejestracja / wybór i tworzenie postaci.
import { api, ApiError, login, register } from '../net/api.js';
import { h, ui } from './dom.js';

export interface CharacterSummary { id: number; name: string; profession: string; level: number; x: number | null; y: number | null }
interface Profession { code: string; name: string; description: string }

function screen(...children: Node[]): HTMLElement {
  ui().replaceChildren();
  const s = h('div', { class: 'screen' }, h('div', { class: 'logo' }, h('span', {}, 'DEAD'), h('b', {}, 'ŁÓDŹ')), ...children);
  ui().append(s);
  return s;
}

export function authScreen(): Promise<void> {
  return new Promise((resolve) => {
    let mode: 'login' | 'register' = 'login';
    const email = h('input', { type: 'email', placeholder: 'E-mail', autocomplete: 'email' });
    const name = h('input', { type: 'text', placeholder: 'Nazwa konta (3–32 znaki)', autocomplete: 'nickname' });
    const pass = h('input', { type: 'password', placeholder: 'Hasło (min. 10 znaków)', autocomplete: 'current-password' });
    const err = h('div', { class: 'error' });
    const submit = h('button', { class: 'primary' }, 'Zaloguj');
    const toggle = h('button', { class: 'link' }, 'Nie masz konta? Załóż je');
    const form = h('form', { class: 'card' }, email, name, pass, err, submit, toggle);
    const render = () => {
      name.style.display = mode === 'register' ? '' : 'none';
      submit.textContent = mode === 'login' ? 'Zaloguj' : 'Załóż konto';
      toggle.textContent = mode === 'login' ? 'Nie masz konta? Załóż je' : 'Masz konto? Zaloguj się';
      pass.autocomplete = mode === 'login' ? 'current-password' : 'new-password';
    };
    toggle.onclick = (e) => { e.preventDefault(); mode = mode === 'login' ? 'register' : 'login'; err.textContent = ''; render(); };
    form.onsubmit = async (e) => {
      e.preventDefault();
      submit.disabled = true; err.textContent = '';
      try {
        if (mode === 'login') await login(email.value.trim(), pass.value);
        else await register(email.value.trim(), name.value.trim(), pass.value);
        resolve();
      } catch (ex) {
        err.textContent = ex instanceof ApiError ? ex.message : 'Brak połączenia z serwerem';
      } finally { submit.disabled = false; }
    };
    render();
    screen(form, h('p', { class: 'attribution' }, 'Mapa: © OpenStreetMap contributors (ODbL) · PRG, BDOT10k © GUGiK'));
  });
}

export function characterScreen(): Promise<CharacterSummary> {
  return new Promise(async (resolve) => {
    const [chars, profs] = await Promise.all([
      api<CharacterSummary[] | { results: CharacterSummary[] }>('/characters/'),
      api<Profession[] | { results: Profession[] }>('/characters/professions/', { auth: false }),
    ]);
    const list = Array.isArray(chars) ? chars : chars.results;
    const professions = Array.isArray(profs) ? profs : profs.results;
    const cards = list.map((c) => {
      const b = h('button', { class: 'char' }, h('b', {}, c.name), h('span', {}, `poziom ${c.level} · ${professions.find((p) => p.code === c.profession)?.name ?? c.profession}`));
      b.onclick = () => resolve(c);
      return b;
    });
    const name = h('input', { type: 'text', placeholder: 'Imię postaci', maxlength: '24' });
    let chosen = professions[0]?.code;
    const desc = h('p', { class: 'desc' }, professions[0]?.description ?? '');
    const profButtons = professions.map((p) => {
      const b = h('button', { class: `prof ${p.code === chosen ? 'on' : ''}`, type: 'button' }, p.name);
      b.onclick = () => {
        chosen = p.code; desc.textContent = p.description;
        profButtons.forEach((x) => x.classList.toggle('on', x === b));
      };
      return b;
    });
    const err = h('div', { class: 'error' });
    const create = h('button', { class: 'primary' }, 'Stwórz postać');
    const form = h('form', { class: 'card wide' }, h('h2', {}, 'Nowa postać'), name, h('div', { class: 'profs' }, ...profButtons), desc, err, create);
    form.onsubmit = async (e) => {
      e.preventDefault();
      try { resolve(await api<CharacterSummary>('/characters/', { body: { name: name.value.trim(), profession: chosen } })); }
      catch (ex) { err.textContent = ex instanceof ApiError ? ex.message : 'Błąd'; }
    };
    screen(h('div', { class: 'card' }, h('h2', {}, 'Twoje postacie'), ...(cards.length ? cards : [h('p', {}, 'Nie masz jeszcze postaci.')])), form);
  });
}
